import { render, staticRenderFns } from "./partner-cert.vue?vue&type=template&id=f547a9a8"
import script from "./partner-cert.vue?vue&type=script&lang=js"
export * from "./partner-cert.vue?vue&type=script&lang=js"
import style0 from "./partner-cert.vue?vue&type=style&index=0&id=f547a9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports